import React, { useState, useContext } from "react";

// Package Import

import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Add as AddIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";

// User Import

import { addvalidation } from "../../../../Services/validations/AdminPortal/Products";
import { headersPost } from "../../../../Services/API";
import { ADMIN_API_ULRS } from "../../../../Services/Routes/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { BATCH_MAIN_TYPES_ENUM_ARRAY } from "../../../../common/Enums";
import { admin_Context } from "../../../../context";
//constants

const initialValue = {
  name: "",
  main_type: "",
  sub_type: "",
  temperature1: "",
  temperature2: "",
  temperature3: "",
  category_id: "",
};

// Component

const Add = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const { categories } = useContext(admin_Context);

  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  // form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      product: {
        name: values?.name,
        main_type: values?.main_type,
        sub_type: values?.sub_type,
        temperature1: values?.temperature1,
        temperature2: values?.temperature2,
        temperature3: values?.temperature3,
        category_id: values?.category_id,
      },
    };
    setOpen(true);

    headersPost(ADMIN_API_ULRS.CREATE_PRODUCT, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setTimeout(() => {
            navigate(-1);
          }, 100);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Render

  return (
    <Paper
      sx={{ p: 2, margin: "auto", maxWidth: 400, flexGrow: 1, borderRadius: 2 }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"center"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Add Products
        </Typography>
        <Formik
          initialValues={initialValue}
          onSubmit={formSubmitHanlder}
          validationSchema={addvalidation}
        >
          {({ values, touched, errors, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 2, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                  maxWidth={250}
                >
                  {/* Name */}

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="name"
                      onChange={handleChange}
                      error={touched?.name && Boolean(errors?.name)}
                      helperText={touched?.name && errors?.name}
                      value={values.name}
                      placeholder="Name"
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(4),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="category_id"
                      onChange={handleChange}
                      error={
                        touched?.category_id && Boolean(errors?.category_id)
                      }
                      helperText={touched?.category_id && errors?.category_id}
                      value={values.category_id}
                      select
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(4),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    >
                      <MenuItem value={""} disabled>
                        Please select a category
                      </MenuItem>
                      {categories?.map((item, index) => (
                        <MenuItem
                          value={item?.id}
                          key={`${index}-categories-type-${item?.id}`}
                        >
                          {item?.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="main_type"
                      onChange={handleChange}
                      error={touched?.main_type && Boolean(errors?.main_type)}
                      helperText={touched?.main_type && errors?.main_type}
                      value={values.main_type}
                      select
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(4),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    >
                      <MenuItem value={""} disabled>
                        Please select a main type
                      </MenuItem>
                      {BATCH_MAIN_TYPES_ENUM_ARRAY?.map((item, index) => (
                        <MenuItem
                          value={item.value}
                          key={`${index}-batch-main-type-${item.value}`}
                        >
                          {item?.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="sub_type"
                      onChange={handleChange}
                      error={touched?.sub_type && Boolean(errors?.sub_type)}
                      helperText={touched?.sub_type && errors?.sub_type}
                      value={values.sub_type}
                      placeholder="Please enter Sub Type"
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(4),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="temperature1"
                      onChange={handleChange}
                      error={
                        touched?.temperature1 && Boolean(errors?.temperature1)
                      }
                      helperText={touched?.temperature1 && errors?.temperature1}
                      value={values.temperature1}
                      placeholder="Please enter temperature 1"
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(4),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="temperature2"
                      onChange={handleChange}
                      error={
                        touched?.temperature2 && Boolean(errors?.temperature2)
                      }
                      helperText={touched?.temperature2 && errors?.temperature2}
                      value={values.temperature2}
                      placeholder="Please enter temperature 2"
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(4),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="temperature3"
                      onChange={handleChange}
                      error={
                        touched?.temperature3 && Boolean(errors?.temperature3)
                      }
                      helperText={touched?.temperature3 && errors?.temperature3}
                      value={values.temperature3}
                      placeholder="please enter temperature 3"
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(4),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    container
                    marginTop={5}
                    display={"flex"}
                    justifyContent={"center"}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      size="large"
                      margin={"auto"}
                      sx={{
                        borderRadius: "37px !important",
                        minWidth: "20%",
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Product
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default Add;
